module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_ideastudy.57acfa6c0e0572a14eb544bc968fc317.png";